import { useEffect, useState } from 'react';
import { BsDot } from 'react-icons/bs';
import { HiMenu } from 'react-icons/hi';
import { MdKeyboardArrowDown, MdKeyboardArrowUp, MdMenuOpen } from 'react-icons/md';
import { Link, useLocation } from 'react-router-dom';
import {
  CLASS_MANAGEMENT,
  CLASS_MANAGEMENT_F,
  DASHBOARD,
  DASHBOARD_F,
  EARNINGS_MANAGEMENT,
  EARNINGS_MANAGEMENT_F,
  ENQUIRY_MANAGEMENT,
  GENERAL_MANAGEMENT,
  GENERAL_MANAGEMENT_F,
  PLAN_MANAGEMENT,
  PLAN_MANAGEMENT_F,
  STUDENT_MANAGEMENT,
  STUDENT_MANAGEMENT_F,
  TUTOR_MANAGEMENT,
  TUTOR_MANAGEMENT_F
} from '../assets/icons';
import NAV_LOGO from '../assets/logos/World_O_Tutor.png';

export default function Sidebar({ open, setOpen }: { open: boolean; setOpen: any }) {
  const menus = [
    { title: 'Dashboard', path: '/', icon: DASHBOARD, iconF: DASHBOARD_F },
    {
      title: 'Tutor Management',
      path: '/tutor-management/manage',
      icon: TUTOR_MANAGEMENT,
      iconF: TUTOR_MANAGEMENT_F,
      subNav: [
        { title: 'Manage', path: '/tutor-management/manage' },
        { title: 'Requests', path: '/tutor-management/requests' }
      ]
    },
    {
      title: 'Student Management',
      path: '/student-management',
      icon: STUDENT_MANAGEMENT,
      iconF: STUDENT_MANAGEMENT_F
    },
    {
      title: 'Payment Detail',
      path: '/earning-payment',
      icon: EARNINGS_MANAGEMENT,
      iconF: EARNINGS_MANAGEMENT_F
    },
    {
      title: 'Book-Trial',
      path: '/book-trial',
      icon: CLASS_MANAGEMENT,
      iconF: STUDENT_MANAGEMENT_F
    },
    {
      title: 'Registrations',
      path: '/registrations',
      icon: ENQUIRY_MANAGEMENT,
      iconF: STUDENT_MANAGEMENT_F
    },
    {
      title: 'Summer Camp',
      path: '/summer-camp/enquiries',
      icon: CLASS_MANAGEMENT,
      iconF: CLASS_MANAGEMENT_F,
      subNav: [
        { title: 'Enquiries', path: '/summer-camp/enquiries' },
        { title: 'AI Summer Registrations', path: '/summer-camp/camp-registrations' }
      ]
    },
    {
      title: 'Earnings Management',
      path: '/earnings-management',
      icon: EARNINGS_MANAGEMENT,
      iconF: EARNINGS_MANAGEMENT_F
    },
    {
      title: 'Plan Management',
      path: '/plan-management/bookings',
      icon: PLAN_MANAGEMENT,
      iconF: PLAN_MANAGEMENT_F,
      subNav: [
        { title: 'Bookings', path: '/plan-management/bookings' },
        { title: 'Change Requests', path: '/plan-management/change-requests' }
      ]
    },
    {
      title: 'Class Management',
      path: '/class-management/classes',
      icon: CLASS_MANAGEMENT,
      iconF: CLASS_MANAGEMENT_F,
      subNav: [
        { title: 'Classes', path: '/class-management/classes' },
        { title: 'Disputes', path: '/class-management/disputes' }
      ]
    },
    {
      title: 'Curriculum',
      path: '/curriculum',
      icon: ENQUIRY_MANAGEMENT,
      iconF: STUDENT_MANAGEMENT_F
    },
    {
      title: 'Enquiry Management',
      path: '/enquiry-management/general',
      icon: ENQUIRY_MANAGEMENT,
      iconF: STUDENT_MANAGEMENT_F,
      subNav: [
        { title: 'General', path: '/enquiry-management/general' },
        { title: 'Support', path: '/enquiry-management/support' },
        { title: 'Raise Ticket', path: '/enquiry-management/ticket-raise' }
      ]
    },
    // {
    //   title: 'Dispute Management',
    //   path: '/dispute-management',
    //   icon: DISPUTE_MANAGEMENT,
    //   iconF: STUDENT_MANAGEMENT_F,
    //   margin: true,
    //   subNav: [{ title: 'Session Queries', path: 'queries' }]
    // },
    {
      title: 'General Management',
      path: '/general-management',
      icon: GENERAL_MANAGEMENT,
      iconF: GENERAL_MANAGEMENT_F,
      subNav: [
        { title: 'T & C', path: '/general-management/legal' },
        { title: 'Categories', path: '/general-management/categories' },
        { title: 'Pricing', path: '/general-management/pricing' }
      ]
    }
  ];

  return (
    <div
      className={`bg-neutralBlue2 min-h-screen flex flex-col items-center py-4 ${open ? 'px-0' : 'px-0'} duration-500`}
    >
      <div className={`w-full flex items-center ${open ? 'justify-between px-4' : 'justify-center px-0'}`}>
        {open && <img src={NAV_LOGO} alt="NAV LOGO" className="h-8" />}
        {open ? (
          <MdMenuOpen size={24} className="cursor-pointer" onClick={() => setOpen(!open)} />
        ) : (
          <HiMenu size={24} className="cursor-pointer" onClick={() => setOpen(!open)} />
        )}
      </div>

      <div className="w-full mt-4 gap-3 flex flex-col">
        {menus?.map((menu, i) => (
          <DashboardItem menu={menu} open={open} key={i} />
        ))}
      </div>
    </div>
  );
}

interface MenuItem {
  title: string;
  path: string;
  icon: string;
  iconF: string;
  subNav?: {
    title: string;
    path: string;
  }[];
}

const DashboardItem = ({ menu, open }: { menu: MenuItem; open: any }) => {
  const [openSubMenu, setSubMenu] = useState(false);
  const [activeTab, setActiveTab] = useState(false);

  const location = useLocation();

  useEffect(() => {
    let currPath = window.location.pathname;
    let paths = currPath.split('/').slice(1);
    let itemPath = menu.path.split('/').slice(1);
    if (`${paths[0]}` === itemPath[0]) {
      if (menu.subNav) {
        setSubMenu(true);
      } else {
        setSubMenu(false);
      }
      setActiveTab(true);
    } else {
      setSubMenu(false);
      setActiveTab(false);
    }
  }, [location]);

  return (
    <div className="w-full h-full flex flex-col">
      <div
        className={`group relative w-full h-full flex items-center justify-between py-4 ${open ? 'px-4' : 'px-2'}
      ${
        activeTab ? 'bg-primary text-white' : 'bg-neutralBlue2 text-primary'
      } hover:bg-neutralBlue1 hover:text-primary overflow-hidden cursor-pointer`}
      >
        <div className={`w-full flex justify-center items-center text-inherit ${open && 'gap-2'}`}>
          <Link to={menu?.path} className="z-50">
            <div className="text-primary text-inherit">
              <img src={activeTab ? menu?.iconF : menu.icon} className="flex items-center w-6" />
            </div>
          </Link>

          <div
            className={`w-full whitespace-pre duration-500 ${
              !open && 'w-0 opacity-0 -translate-x-28 overflow-y-scroll'
            } z-10`}
          >
            <div className="w-full flex items-center justify-between">
              <Link to={menu.path} className="w-full">
                <span
                  className={`text-sm font-medium ${activeTab ? 'text-white' : 'text-black'} group-hover:text-primary`}
                >
                  {menu.title}
                </span>
              </Link>

              {menu.subNav ? (
                <div className="cursor-pointer" onClick={() => setSubMenu(!openSubMenu)}>
                  {openSubMenu ? <MdKeyboardArrowUp size={20} /> : <MdKeyboardArrowDown size={20} />}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {open && openSubMenu && menu.subNav && (
        <div className="h-full flex flex-col ml-[20%] transition-all py-2">
          {menu.subNav.map((item: any, index: number) => (
            <SubMenuItem item={item} key={index} />
          ))}
        </div>
      )}
    </div>
  );
};

const SubMenuItem = ({ item }: { item: any }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(false);

  useEffect(() => {
    let currPath = window.location.pathname;
    let paths = currPath.split('/').slice(1);
    let itemPath = item.path.split('/').slice(1);
    if (`${paths[1]}` === itemPath[1]) {
      setActiveTab(true);
    } else {
      setActiveTab(false);
    }
  }, [location]);

  return (
    <Link to={item.path} className="flex items-center gap-2 py-1">
      <BsDot className={`text-2xl ${activeTab ? 'text-primary' : 'text-black'}`} />
      <h3 className={`text-sm ${activeTab ? 'text-primary' : 'text-black'} font-medium py-1 cursor-pointer`}>
        {item.title}
      </h3>
    </Link>
  );
};
